import React from 'react';
import { Link } from 'react-router-dom';

const NavItem = ({ icon, label, path, subNavs = [], isActive, isHeaderManu }) => {

  return (
    <li className="relative group">
      {/* Main Navigation Item */}
      <div
        className={`py-3 flex items-center gap-3 cursor-pointer hover:bg-[#CCE0F0] dark:hover:bg-[#444444] ${isActive ? 'bg-[#CCE0F0] dark:bg-[#B1B1B133]' : ''
          }`}
      >
        {subNavs.length === 0 ? (
          <Link to={path} className="flex items-center gap-3 cursor-pointer">
            {isActive && (
              <div className="absolute left-0 rounded-full w-1.5 h-8 bg-[#1B75BC] dark:bg-[#FFFFFF]"></div>
            )}
            {icon && <img className="pl-5 dark:invert" src={icon} alt={`${label} icon`} />}
            <span className={`font-rubik !text-black font-extrabold dark:text-[#CED8DF] px-1 whitespace-nowrap ${isHeaderManu ? 'block md:hidden': ''}`} style={{ color: '#000000', fontWeight: 400 }}>{label}</span>
          </Link>
        ) : (

          <>
            {isActive && (
              <div className="absolute left-0 rounded-full w-1.5 h-8 bg-[#1B75BC] dark:bg-[#FFFFFF]"></div>
            )}
            {icon && <img className="pl-5 dark:invert" src={icon} alt={`${label} icon`} />}
            <span className={`font-rubik !text-black font-extrabold dark:text-[#CED8DF] px-1 whitespace-nowrap ${isHeaderManu ? 'block md:hidden': ''}`} style={{ color: '#000000', fontWeight: 400 }}>{label}</span>
          </>
        )
        }
      </div>
      {/* Sub-Navigation */}
      {subNavs.length > 0 && (
        <ul className={`${isActive ? '' : 'hidden'} left-full top-0  group-hover:block list-disc ml-8 bg-white dark:bg-[#333333] shadow-lg shadow=[#CCE0F0] rounded-lg p-2 space-y-1 transition-all`}>
          {subNavs.map((subNav, index) => (
            <li
              key={index}
              // ${subNav?.path?.state?.activeConstruct === location?.state?.activeConstruct ? 'bg-[#CCE0F0]' : ''}
              className={`hover:bg-[#CCE0F0] dark:hover:bg-[#444444] rounded py-1 px-1`}
            >
              <Link
                to={subNav.path}
                className="flex items-center gap-2 text-md text-nowrap !text-black font-extrabold dark:text-[#CED8DF]"
                style={{ color: '#000000', fontWeight: 800 }}
              >
                {subNav.icon && (
                  <img className="w-4 h-4" src={subNav.icon} alt={`${subNav.label} icon`} />
                )}
                {subNav.label}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default NavItem;
